/* OH Bubbles — activates Relume's static interaction markup (no React).
   Uses embla (CDN global EmblaCarousel) + gsap (global gsap/ScrollTrigger). */
(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    initTabs();
    initCarousels();
    initCountUp();
    initStickyReveal();
    initAutoHero();
    initPrices();
  });

  /* PRICES — fill [data-price="key"] from window.OHB_PRICES (Shopify-sourced).
     Optional [data-price-prefix] / [data-price-suffix] attrs. */
  function initPrices() {
    var P = window.OHB_PRICES || {};
    document.querySelectorAll("[data-price]").forEach(function (el) {
      var key = el.getAttribute("data-price");
      if (!(key in P)) return;
      var pre = el.getAttribute("data-price-prefix") || "$";
      var suf = el.getAttribute("data-price-suffix") || "";
      el.textContent = pre + P[key] + suf;
    });
  }

  /* AUTO-HERO — recreates Relume Header103 (framer-motion) in vanilla + GSAP:
     auto-advancing tabbed hero, progress-bar fill, content fade-up. */
  function initAutoHero() {
    document.querySelectorAll("[data-autohero]").forEach(function (root) {
      var panels = [].slice.call(root.querySelectorAll("[data-hero-panel]"));
      var tabs = [].slice.call(root.querySelectorAll("[data-hero-tab]"));
      var progs = tabs.map(function (t) { return t.querySelector("[data-hero-progress]"); });
      var n = panels.length, cur = -1, timer = null, DUR = 5000;
      var hasGsap = typeof gsap !== "undefined";
      panels.forEach(function (p) { p.style.transition = "opacity .4s ease"; p.style.opacity = "0"; p.style.pointerEvents = "none"; });
      function show(i) {
        if (i === cur) return;
        cur = i;
        panels.forEach(function (p, idx) {
          p.style.opacity = idx === i ? "1" : "0";
          p.style.zIndex = idx === i ? "10" : "0";
          p.style.pointerEvents = idx === i ? "auto" : "none";
        });
        tabs.forEach(function (t, idx) {
          t.classList.toggle("text-neutral-white", idx === i);
          t.classList.toggle("text-neutral-light", idx !== i);
        });
        var c = panels[i].querySelector("[data-hero-content]");
        if (hasGsap && c) gsap.fromTo(c, { y: "12%", opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" });
        progs.forEach(function (p) { if (!p) return; if (hasGsap) gsap.killTweensOf(p); p.style.transition = "none"; p.style.width = "0%"; });
        var pr = progs[i];
        if (pr) {
          if (hasGsap) gsap.fromTo(pr, { width: "0%" }, { width: "100%", duration: DUR / 1000, ease: "none" });
          else { pr.style.transition = "width " + DUR + "ms linear"; requestAnimationFrame(function () { pr.style.width = "100%"; }); }
        }
        schedule();
      }
      function schedule() { clearTimeout(timer); timer = setTimeout(function () { show((cur + 1) % n); }, DUR); }
      tabs.forEach(function (t, idx) { t.addEventListener("click", function () { show(idx); }); });
      show(0);
    });
  }

  /* TABS — Relume radix-style tablist/tab/tabpanel */
  function initTabs() {
    document.querySelectorAll('[role="tablist"]').forEach(function (list) {
      var tabs = [].slice.call(list.querySelectorAll('[role="tab"]'));
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute("aria-selected", on ? "true" : "false");
            t.setAttribute("data-state", on ? "active" : "inactive");
          });
          var id = tab.getAttribute("aria-controls");
          document.querySelectorAll('[role="tabpanel"]').forEach(function (p) {
            var on = p.id === id;
            p.hidden = !on;
            p.setAttribute("data-state", on ? "active" : "inactive");
          });
        });
      });
    });
  }

  /* CAROUSEL — embla on Relume carousel DOM */
  function initCarousels() {
    if (typeof EmblaCarousel === "undefined") return;
    document
      .querySelectorAll('[aria-roledescription="carousel"]')
      .forEach(function (root) {
        var container = root.querySelector(".flex");
        if (!container) return;
        var viewport = container.parentElement;
        var plugins =
          typeof EmblaCarouselAutoplay !== "undefined"
            ? [EmblaCarouselAutoplay({ delay: 5000, stopOnInteraction: false })]
            : [];
        var embla = EmblaCarousel(viewport, { loop: true }, plugins);
        var dots = [].slice.call(root.querySelectorAll("button.size-2"));
        var prev = findBtn(root, "Previous slide");
        var next = findBtn(root, "Next slide");
        if (prev) {
          prev.disabled = false;
          prev.addEventListener("click", function () { embla.scrollPrev(); });
        }
        if (next) {
          next.disabled = false;
          next.addEventListener("click", function () { embla.scrollNext(); });
        }
        dots.forEach(function (d, i) {
          d.addEventListener("click", function () { embla.scrollTo(i); });
        });
        function sync() {
          var s = embla.selectedScrollSnap();
          dots.forEach(function (d, i) {
            d.classList.toggle("bg-black", i === s);
            d.classList.toggle("bg-neutral-light", i !== s);
          });
        }
        embla.on("select", sync);
        sync();
      });
  }
  function findBtn(root, label) {
    var found = null;
    root.querySelectorAll("button").forEach(function (b) {
      var sr = b.querySelector(".sr-only");
      if (sr && sr.textContent.trim() === label) found = b;
    });
    return found;
  }

  /* COUNT-UP — add data-countup="47000" to a number element */
  function initCountUp() {
    var els = document.querySelectorAll("[data-countup]");
    if (!els.length) return;
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { io.observe(el); });
    function run(el) {
      var target = parseFloat(el.getAttribute("data-countup")) || 0;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 1100, 1);
        el.textContent = Math.round(target * p).toLocaleString();
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
  }

  /* STICKY REVEAL — gentle fade-up on scroll for [data-reveal] (GSAP if present) */
  function initStickyReveal() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!els.length) return;
    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
      els.forEach(function (el) {
        gsap.fromTo(
          el,
          { opacity: 0, y: 24 },
          {
            opacity: 1, y: 0, duration: 0.8, ease: "power2.out",
            scrollTrigger: { trigger: el, start: "top 85%" },
          }
        );
      });
    } else {
      els.forEach(function (el) { el.style.opacity = 1; });
    }
  }
})();
